export const DEVICE_TYPES = [
  { value: 'TIVE', labelId: 'linkDeviceToJob.tive', model: 'TT7100' },
  { value: 'SENSOS', labelId: 'linkDeviceToJob.sensos', model: 'SENSOS' },
];

export function getDeviceModel(deviceType) {
  return DEVICE_TYPES.find(type => type.value === deviceType)?.model;
}

export function parseLinkDeviceContext(search) {
  const params = new URLSearchParams(search);

  return {
    jobNumber: params.get('jobNumber'),
    clientToken: params.get('clientToken'),
  };
}

export function validateLinkDeviceForm({ deviceId, deviceType, jobNumber }) {
  const errors = {
    deviceId: !deviceId,
    deviceType: !deviceType,
  };
  const jobNumberMissing = !jobNumber;
  const isValid = !errors.deviceId && !errors.deviceType && !jobNumberMissing;

  return { isValid, errors, jobNumberMissing };
}

export function buildLinkDeviceInput(form, context) {
  return {
    jobNumber: context.jobNumber,
    deviceType: form.deviceType,
    deviceModel: getDeviceModel(form.deviceType),
    deviceId: form.deviceId,
    clientToken: context.clientToken,
  };
}
